import type { DependencyContainer } from 'tsyringe';
import { IAdoptionGatewayToken } from './AdoptionGateway';
import { OlapAdoptionGateway } from './OlapAdoptionGateway';

/**
 * Binds the adoption gateway to the live OLAP implementation, which computes the
 * composite score and drivers from telemetry via the analytics gateway. Swap for
 * {@link FixtureAdoptionGateway} to develop the screens offline against sample data.
 */
export function registerAdoption(container: DependencyContainer): void {
    container.register(IAdoptionGatewayToken, { useClass: OlapAdoptionGateway });
}
